import React from "react";

import NavigationPanelCategory from "./NavigationPanelCategory";

import "./navigationPanel.css";
import "./navigationMenuGrip.css";

const navigationPanel = (props) => {
  // console.log("NAVBAR] : ", props.cvParts);

  let cvParts = props.cvParts.map((part) => (
    <NavigationPanelCategory key={Object.keys(part)[0]} cvPart={part} {...props} />
  ));
  let navMenuCls = props.appNavState.active ? "Navigation-panel menu-open" : "Navigation-panel";

  return (
    <nav className={navMenuCls}>
      <div className="nav-panel__items-container">
        <ul className="nav-panel__items">{cvParts}</ul>
        <div className="nav-panel__grip" onClick={() => props.appNavState.toggle()}>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    </nav>
  );
};

export default navigationPanel;
